module.exports = __webpack_public_path__ + "img/modal-close-icon.svg";